exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#asseco-directmessaging-preview-window{height:400px}", ""]);

// exports
